import { render, staticRenderFns } from "./CardMonths.vue?vue&type=template&id=1ece5908"
import script from "./CardMonths.vue?vue&type=script&lang=js"
export * from "./CardMonths.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports